import { CSSProperties } from 'react';

export const showButtonStyles: CSSProperties = {
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '22px',
  marginLeft: '-16px',
  marginBottom: '10px',
};
export const showContainerStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  width: 'fit-content',
  alignItems: 'start',
  // paddingLeft: '1px',
};
export const showTextStyles: CSSProperties = {
  fontSize: '14px',
  lineHeight: '22px',
  textAlign: 'left',
};

export const inputFormStyles: CSSProperties = {
  width: '100%',
  borderRadius: '2px',
  height: '37px',
};

export const dateOfTransactionFieldStyle: CSSProperties = {
  width: '100%',
  height: '37px',
};

export const uploadButtonStyle: CSSProperties = {
  // marginTop: '25px',
  // marginBottom: '50px',
};

export const inputSimpleStyle: CSSProperties = {
  height: '35px',
};
